import { EChartsCoreOption } from 'echarts';
import { useMemo } from 'react';
import ChartComponent from 'src/helpers/Echarts/ChartComponent';
import { generateToDChartOptions, zoneColors } from './modules';

type Props = {
    data: any,
    type: string
}

const TODZoneChart = ({ data, type }: Props) => {



    const { beforeMYTData, afterMYTData } = useMemo(() => {

        
        const beforeMYTData: any[] = [];
        const afterMYTData: any[] = [];
        const zones: any = ['A', 'B', 'C', 'D'];
        const metric = type == "units" ? type : "rebateAmount"

        
        data && zones.forEach((zoneKey: any) => {

            const zone = data[`zone${zoneKey}` as keyof object];
            if (!zone) return; // Skip if zone data is missing

            const beforeMYT = zone.beforeMYT
            const afterMYT = zone.afterMYT

            console.log({ data, zone, beforeMYT, afterMYT });

            if (beforeMYT) {
                beforeMYTData.push({
                    value: Number(beforeMYT[metric]).toFixed(2),
                    itemStyle: {
                        color: beforeMYT[metric] && Number(beforeMYT[metric]) < 0 ? '#FF0000' : zoneColors[`Zone ${zoneKey}`],
                    }
                });
            }

            if (afterMYT) {
                afterMYTData.push({
                    value: Number(afterMYT[metric]).toFixed(2),
                    itemStyle: {
                        color:  afterMYT[metric] < 0 ? '#FF0000' : zoneColors[`Zone ${zoneKey}`]
                    }
                });
            }
        });


        return { beforeMYTData, afterMYTData };
    }, [data, type])

    console.log({ data, beforeMYTData, afterMYTData, type,zoneColors });


    const options: EChartsCoreOption = useMemo(
        () => (
            {

                "tooltip": {
                    "trigger": "axis",
                    "axisPointer": { "type": "shadow" },
                },
                "grid": {
                    "top": 0,
                    "bottom": 0,
                    "left": 50,
                    "right": 0
                },
                "xAxis": {
                    show: false
                },
                "yAxis": {
                    "type": "category",
                    "axisLine": { "show": false },
                    "axisLabel": { "show": true },
                    "axisTick": { "show": false },
                    "splitLine": { "show": false },
                    "data": ["Zone A", "Zone B", "Zone C", "Zone D"]
                },
                "series": [
                    {
                        "name": "Before MYT",
                        "type": "bar",
                        // "stack": "Total",
                        "label": { "show": true, "formatter": "{c}", "position": "insideLeft" },
                        "data": beforeMYTData
                        // "data": [
                        //     { "value": 1334100, "itemStyle": { "color": "#1e1b4b" } },
                        //     { "value": 1489301, "itemStyle": { "color": "#60a5fa" } },
                        //     { "value": 503250, "itemStyle": { "color": "#fdba74" } },
                        //     { "value": 683900, "itemStyle": { "color": "#1d4ed8" } }
                        // ]
                    },
                    {
                        "name": "After MYT",
                        "type": "bar",
                        // "stack": "Total",
                        "label": { "show": true, "formatter": "{c}", "position": "insideLeft" },
                        "data": afterMYTData
                        // "data": [
                        //     { "value": 1000575, "itemStyle": { "color": "#35325d" } },
                        //     { "value": 496433.6666666666, "itemStyle": { "color": "#70aefb" } },
                        //     { "value": 1330639.4444444445, "itemStyle": { "color": "#fdba74" } },
                        //     { "value": 1182902.888888889, "itemStyle": { "color": "#1d4ed8" } }
                        // ]
                    }
                ]
            }
        ),
        [beforeMYTData, afterMYTData]
    );

    return (

        <div className=' relative bg-slate-200'>
            <ChartComponent options={options} style={{ height: "250px" }} />
        </div>

    );
}

export default TODZoneChart